import { Config } from '~/stores/configStore';

export default async function (config: Config[]): Promise<boolean> {
  const configStore = useConfigStore();
  await configStore.fetch();
  return config.every((config) => configStore.config?.[config]);
}
